import { createBrowserHistory } from 'history';
const historyConfig = {
    basename: '',
    //forceRefresh: true
};

export const history = createBrowserHistory(historyConfig);